module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('mobile-input', {
    attrs: {
      "inputType": _vm.CONF.inputType.mobile,
      "errData": _vm.errData
    },
    on: {
      "btnEnable": _vm.btnEnable,
      "btnDisable": _vm.btnDisable,
      "hideImgCode": _vm.hideImgCode
    }
  }), _vm._v(" "), _c('img-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgCodeShow),
      expression: "imgCodeShow"
    }],
    attrs: {
      "options": _vm.imgCodeData
    },
    on: {
      "mobileCodeSendSuccess": _vm.mobileCodeSendSuccess
    }
  }), _vm._v(" "), _c('mobile-code', {
    attrs: {
      "mobileCodeBtnState": _vm.mobileCodeBtnState,
      "sendMsg": _vm.sendMsg,
      "inputType": _vm.CONF.inputType.mobile,
      "codeErrData": _vm.codeErrData,
      "sendMsgTimer": _vm.sendMsgTimer
    },
    on: {
      "mobileCodeBtnEnable": _vm.mobileCodeBtnEnable,
      "mobileCodeSuccess": _vm.mobileCodeSuccess,
      "showImgCode": function($event) {
        return _vm.showImgCode()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendOneMsg && _vm.countryCodeIndex == 0),
      expression: "sendOneMsg&&countryCodeIndex==0"
    }],
    staticClass: "font-size12 color-cue voice"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendVoiceMsgBtnState == _vm.CONF.mobileCodeState.enable),
      expression: "sendVoiceMsgBtnState== CONF.mobileCodeState.enable"
    }]
  }, [_vm._v("收不到短信，"), _c('span', {
    staticClass: "color-voice",
    on: {
      "click": function($event) {
        return _vm.showImgCode(true)
      }
    }
  }, [_vm._v("获取语音验证码")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendVoiceMsgBtnState == _vm.CONF.mobileCodeState.disable),
      expression: "sendVoiceMsgBtnState== CONF.mobileCodeState.disable"
    }]
  }, [_vm._v("收不到短信，"), _c('span', [_vm._v("获取语音验证码")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendVoiceMsgBtnState == _vm.CONF.mobileCodeState.timeout),
      expression: "sendVoiceMsgBtnState== CONF.mobileCodeState.timeout"
    }]
  }, [_vm._v(_vm._s(_vm.voiceTimer) + "s后可重新获取")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: "submitBtnState == CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: "submitBtnState == CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-cue color-cue font-size14"
  }, [_vm._v("首次使用验证码登录直接注册新帐号")]), _vm._v(" "), _c('other-way', [_c('div', {
    staticClass: "option-account font-size14 color-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.CONF.urlList.Login.path + _vm.search
    }
  }, [_vm._v("帐号密码登录>")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75f38c88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/logincode.vue
// module id = 135
// module chunks = 1